
import React, { useState, useEffect, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    Paper,
    Tooltip,
    Chip
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AddIcon from "@mui/icons-material/Add";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        EmailRecipientModel,
        RecordModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import {validateEmailField} from '../../utils/fieldValidations';


export const EmailBodyComponent: React.FC<{
  body: string,
  onChange: (newValue: string) => void
}> = ({
  body,
  onChange
}) => {

  const styles = ContainerClasses();

  const editorReference = useRef<HTMLDivElement>(null);
  const isInitialRender = useRef<boolean>(true);

  useEffect(() => {
    if(editorReference.current && isInitialRender.current){
      //render initially
      editorReference.current.innerHTML = body
      isInitialRender.current = false
    }
    if(editorReference.current && document.activeElement !== editorReference.current){
      //injected by change of loading new body
      //(and not by user interaction)
      editorReference.current.innerHTML = body
    }
  }, [body]);


  const handleInput = () => {
    if(editorReference.current) {
      onChange(editorReference.current.innerHTML)
    }
  }


  return (
   <Box sx={{gap: '1rem',
             pt: '1rem',
             pl: '1rem',
             pr: '1rem',}}>

     <Typography
        variant="subtitle1"
      >
       Body:
     </Typography>


    <Box
      ref={editorReference}
      contentEditable
      onInput={handleInput}
      sx={{
        minHeight: "25rem",
        border: "2px solid black",
        padding: 2,
        borderRadius: 1,
        overflowY: "auto",
        cursor: "text",
        backgroundColor: "#fafafa"
      }}
    >
  </Box>
  </Box>
    )
};
